export const routePaths = Object.freeze({
  LOGIN: '/login',
  ENTER_MFA: '/login/enter-mfa',
})
